import React, { useEffect, useState } from 'react';

import { Box } from '../../utils/material-ui-core';

interface JobRunTickerProps {
  interval: number;
  unit: 'minutes' | 'hours';
  mode: number
}

const JobRunTicker: React.FC<JobRunTickerProps> = ({ interval, unit, mode }) => {
  const [nextRunTime, setNextRunTime] = useState<Date>(new Date());
  const [timeLeft, setTimeLeft] = useState<string>('');
  const [isRunning, setIsRunning] = useState<boolean>(false);

  const calculateNextRunTime = (): Date => {
    const now = new Date();
    let nextRun = new Date(now);

    if (unit === 'minutes') {
      nextRun.setMinutes(Math.ceil(now.getMinutes() / interval) * interval, 0, 0);
      if (nextRun <= now) {
        nextRun.setMinutes(nextRun.getMinutes() + interval);
      }
    } else if (unit === 'hours') {
      nextRun.setHours(nextRun.getHours() + interval, 0, 0);
    }

    return nextRun;
  };

  const calculateTimeLeft = (endTime: Date): string => {
    const now = new Date();
    const difference = endTime.getTime() - now.getTime();
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    return `${minutes}m ${seconds}s`;
  };

  useEffect(() => {
    const nextRun = calculateNextRunTime();
    setNextRunTime(nextRun);
    setIsRunning(true);

    const intervalMs = unit === 'minutes' ? interval * 60 * 1000 : interval * 60 * 60 * 1000;
    const intervalId = setInterval(() => {
      const newNextRun = calculateNextRunTime();
      setNextRunTime(newNextRun);
      setIsRunning(true);
    }, intervalMs);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interval, unit]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const newNextRun = calculateNextRunTime();
      setNextRunTime(newNextRun);
      setIsRunning(true);
    }, nextRunTime.getTime() - new Date().getTime());

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextRunTime]);

  useEffect(() => {
    const countdown = setInterval(() => {
      const timeLeftString = calculateTimeLeft(nextRunTime);
      setTimeLeft(timeLeftString);
      const now = new Date();
      const timeSinceLastRun = now.getTime() - (nextRunTime.getTime() - interval * (unit === 'minutes' ? 60 * 1000 : 60 * 60 * 1000));
      if (timeSinceLastRun < 2 * 60 * 1000) {
        setIsRunning(true);
      } else {
        setIsRunning(false);
      }
    }, 1000); // Update every second

    return () => clearInterval(countdown);
  }, [nextRunTime, interval, unit]);

  return (
    <>
      {
        mode === 1 ?
          <Box>
            {isRunning ? 'Job is running' : `${timeLeft}`}
          </Box>
          :
          <Box p={2} display={"flex"} justifyContent={"flex-end"} alignContent={"center"} style={{ fontSize: '0.9em' }}>
            Next job runs @ {nextRunTime.toLocaleTimeString()}
            &nbsp;&nbsp;&nbsp;
            {isRunning ? 'Job is running' : `Time left: ${timeLeft}`}
          </Box>
      }
    </>
  );
};

export default JobRunTicker;
